import {TextStyle, ViewStyle} from 'react-native';

export default class SpeechBalloonResourceOptions {
  constructor(
    public containerStyle?: ViewStyle,
    public textStyle?: TextStyle,
    public wideTextStyle?: TextStyle,
    public voiceIconStyle?: ViewStyle,
    public adjustable?: {[key: string]: {[key: string]: string}},
    public wideAdjustable?: {[key: string]: {[key: string]: string}},
  ) {}
}
